"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var Box_1 = require("@material-ui/core/Box");
var core_1 = require("@material-ui/core");
var customCheckboxStyles_1 = require("./customCheckboxStyles");
var CheckBox_1 = require("@material-ui/icons/CheckBox");
var CheckBoxOutlineBlank_1 = require("@material-ui/icons/CheckBoxOutlineBlank");
var RadioButtonUncheckedOutlined_1 = require("@material-ui/icons/RadioButtonUncheckedOutlined");
var CheckCircle_1 = require("@material-ui/icons/CheckCircle");
var ShowIfTranslationExists_1 = require("../../../../../common/components/ShowIfTranslationExists");
var react_intl_1 = require("react-intl");
var EnquiryFormField_1 = require("../../enum/EnquiryFormField");
var cache_1 = require("../../../../common/graphql/cache");
var client_1 = require("@apollo/client");
var JourneyTypes_1 = require("../../../../../../../common/enum/JourneyTypes");
var TermsAndConditionsModal_1 = require("../termsAndConditionsModal/TermsAndConditionsModal");
var Translation_1 = require("../../../../../common/components/presentation/Translation/Translation");
exports.CustomCheckbox = function (_a) {
    var formData = _a.formData;
    var styles = customCheckboxStyles_1.default();
    var journeyType = client_1.useReactiveVar(cache_1.activeJourneyType);
    var value = formData.value, label = formData.label, id = formData.id, onChange = formData.onChange;
    var handleChange = function (e) {
        onChange(e.target.checked);
    };
    var _b = core_1.useTheme().checkoutLite.enquiryForm, checkboxIconCircle = _b.checkboxIconCircle, showMarketingInformationDisclaimer = _b.showMarketingInformationDisclaimer, useModalTermsAndConditions = _b.useModalTermsAndConditions, showOnlyLegalDisclaimerMandatoryLegend = _b.showOnlyLegalDisclaimerMandatoryLegend;
    var _c = react_1.useState(false), isModalOpen = _c[0], setIsModalOpen = _c[1];
    var termsWithUrl = react_1.useMemo(function () {
        return (<core_1.Typography className={styles.disclaimer} dangerouslySetInnerHTML={{ __html: label }} onClick={function (e) {
            if (!e.target.hasAttribute('href')) {
                e.preventDefault();
            }
        }} data-test={"text:enquiryForm:" + id}/>);
    }, [label]);
    var intl = react_intl_1.useIntl();
    var renderMandatoryCondition = showOnlyLegalDisclaimerMandatoryLegend
        ? id === EnquiryFormField_1.EnquiryFormFields.LEGAL_DISCLAIMER
        : true;
    return (<Box_1.default className={styles.container}>
      {id !== EnquiryFormField_1.EnquiryFormFields.MARKETING_INFORMATION && renderMandatoryCondition && (<ShowIfTranslationExists_1.default translationKey={'trans__checkout__enquiry_form__mandatory_legend'}>
          <>
            <Box_1.default className={styles.note}>
              <core_1.Typography data-test={"mandatory:label:" + id}>
                {intl.formatMessage({ id: 'trans__checkout__enquiry_form__mandatory_legend' })}
              </core_1.Typography>
            </Box_1.default>
            {showMarketingInformationDisclaimer && journeyType === JourneyTypes_1.JourneyTypes.RESERVE_ONLINE && (<core_1.Typography className={styles.marketingInformationDisclaimer} dangerouslySetInnerHTML={{
        __html: intl.formatMessage({
            id: 'trans__checkout__confirmation_page__summary__reservation_reservation_tooltip',
        }),
    }}/>)}
          </>
        </ShowIfTranslationExists_1.default>)}
      <Box_1.default className={styles.formControlContainer}>
        <core_1.Checkbox icon={checkboxIconCircle ? <RadioButtonUncheckedOutlined_1.default /> : <CheckBoxOutlineBlank_1.default />} checkedIcon={checkboxIconCircle ? <CheckCircle_1.default /> : <CheckBox_1.default />} color={'primary'} id={id} checked={!!value} value={value} size={'small'} onChange={handleChange} data-test={"checkbox:" + id} classes={{
        root: styles.root,
    }}/>
        <core_1.Typography className={styles.label} component={'span'} data-test={"checkbox:label:" + id}>
          {termsWithUrl}
        </core_1.Typography>
      </Box_1.default>
      {journeyType === JourneyTypes_1.JourneyTypes.RESERVE_ONLINE && useModalTermsAndConditions && (<core_1.Typography className={styles.modalTitle}>
          <Translation_1.default id="trans__checkout__enquiry_form__reserve_online_terms_and_conditions_2"/>
          &nbsp;
          <Box_1.default component="span" data-test={"enquiryForm:modal:" + id} className={styles.clickable} onClick={function () { return setIsModalOpen(true); }}>
            <Translation_1.default id="trans__checkout__enquiry_form__reserve_online_terms_and_conditions_title_page"/>
          </Box_1.default>
        </core_1.Typography>)}
      <TermsAndConditionsModal_1.default isOpen={isModalOpen} toggleModal={setIsModalOpen} id={id}/>
    </Box_1.default>);
};
exports.default = exports.CustomCheckbox;
